
export class userlogged {
    userName: string;
}